<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import moment from "moment";
import { mapGetters, mapActions, mapState } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Customer Balance Details",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      current_date: moment(new Date()).format("YYYY-MM-DD"),
      title: "Customer Balance Details",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Customer Balance Details",
          active: true,
        },
      ],

      json_fields: {
        NAME: "customer.name",
        CONTACT: "customer.contact",
        DATE: "date",
        CATEGORY: "Category",
        RECIEVED_VIA: "mode",
        DEBIT: "amountOut",
        CREDIT: "amount",
        BALANCE: "newbalance",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],

      total_amount: 0,
      total_paid: 0,
      total_balance: 0,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      totals: {
        totalin: 0,
        totalout: 0,
      },
      filterRecords: {
        id: atob(this.$route.params.id),
        datefrom: null,
        dateto: moment(new Date()).format("YYYY-MM-DD"),
      },
      fields: [
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "Category",
          sortable: true,
          label: "CATEGORY",
        },
        {
          key: "mode",
          sortable: true,
          label: "RECEIVED VIA",
        },
        {
          key: "amountOut",
          sortable: true,
          label: "DEBIT",
        },
        {
          key: "amount",
          sortable: true,
          label: "CREDIT",
        },
        {
          key: "newbalance",
          sortable: true,
          label: "BALANCE",
        },
        {
          key: "actions",
          sortable: true,
          label: "Actions",
        }
      ],
    };
  },
  computed: {
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("customers", ["CustomerBalanceDetails", "filterStatus"]),
    ...mapGetters("setting", ["ReceiptSettings"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.CustomerBalanceDetails ? this.CustomerBalanceDetails.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.CustomerBalanceDetails ? this.CustomerBalanceDetails.length : 1;
  },
  methods: {
    ...mapActions({
      FetchBalanceDetails: "customers/fetchCustomerBalanceDetails",
      fetchReceiptSettings: "setting/fetchReceiptSettings",
    }),
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    /**
      * Search the table data with search input
      */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    Receipt_print(newValue) {
      window.open(
        `https://${window.location.host}/receipts/depositreceipt.php?id=${btoa(newValue)}`
      );
    },
    Viewdetails(tid, category) {
      if (category == 'Sale' || category == 'Sale & Payment' || category == 'Payment') {
        this.$router.push(`/sale_details/${btoa(tid)}`);
      } else if (category == 'Deposit') {
        this.$router.push(`/customerdeposit_details/${btoa(tid)}`);
      } else if (category == 'Refund') {
        this.$router.push(`/refund_details/${btoa(tid)}`);
      } else if (category == 'Imported Debtor') {
        this.$router.push(`/debtor_details/${btoa(tid)}`);
      } else if (category == 'Sale Return') {
        this.$router.push(`/salereturn_details/${btoa(tid)}`);
      }
    },
    FilterRecords() {
      this.FetchBalanceDetails(this.filterRecords);
    },
    printDescriptiveLedger() {
      this.$router.push(`/customer/descriptive_balancedetails/${btoa(this.filterRecords.id)}`);
    },
    printLedger() {
      this.$router.push(`/customer/print_balance_details/${btoa(this.filterRecords.id)}/${btoa(this.filterRecords.datefrom)}/${btoa(this.filterRecords.dateto)}`);
    }
  },
  updated() {
    let total_in = 0;
    let total_out = 0;
    if (this.CustomerBalanceDetails) {
      this.CustomerBalanceDetails.forEach((item) => {
        total_in = total_in + parseInt(item.amount);
      });
      this.totals.totalin = total_in;
      this.CustomerBalanceDetails.forEach((item) => {
        total_out = total_out + parseInt(item.amountOut);
      });
      this.totals.totalout = total_out;
    }
  },
  created() {
    this.FetchBalanceDetails(this.filterRecords);
    this.fetchReceiptSettings();
  },
};
</script>

<template>
  <Layout>

    <Toasts :show-progress="true" :rtl="true" :max-messages="20" :time-out="3000" :closeable="false" :solid="true">
    </Toasts>

    <!-- REPORT TITLE -->
    <div class="row py-3 text-center"
      v-if="CustomerBalanceDetails && CustomerBalanceDetails.length > 0 && filterRecords.datefrom == null">
      <div class="col-12">
        <h4 class="text-primary text-uppercase">
          CUSTOMER PAYMENT REPORT FOR
          {{ CustomerBalanceDetails[0].customer.name }}
          - {{ CustomerBalanceDetails[0].customer.contact }}
        </h4>
      </div>
    </div>

    <div class="row py-3 text-center"
      v-if="CustomerBalanceDetails && CustomerBalanceDetails.length > 0 && filterRecords.datefrom != null">
      <div class="col-12">
        <h4 class="text-primary text-uppercase">
          CUSTOMER PAYMENT REPORT FOR
          {{ CustomerBalanceDetails[0].customer.name }}
          - {{ CustomerBalanceDetails[0].customer.contact }}
          <br />
          FROM {{ filterRecords.datefrom }} TO {{ filterRecords.dateto }}
        </h4>
      </div>
    </div>

    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">

        <div class="card">
          <div class="card-body">

            <!-- FILTERS -->
            <div class="row mb-3 align-items-end">

              <div class="col-12 col-md-3 mb-2">
                <label>FROM</label>
                <input type="date" v-model="filterRecords.datefrom" class="form-control" />
              </div>

              <div class="col-12 col-md-3 mb-2">
                <label>TO</label>
                <input type="date" v-model="filterRecords.dateto" class="form-control" />
              </div>

              <div class="col-12 col-md-2 mb-2">
                <button class="btn w-100" style="background-color:#e612e6;border-color:#e612e6;color:#fff"
                  @click="FilterRecords()">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner v-show="filterStatus" variant="light" small></b-spinner>
                </button>
              </div>

            </div>

            <!-- ACTION BUTTONS -->
            <div class="row mb-3">
              <div class="col-12 d-flex flex-wrap gap-2">

                <download-excel class="btn" style="background-color:#e612e6;border-color:#e612e6;color:#fff"
                  :data="CustomerBalanceDetails" :fields="json_fields"
                  :worksheet="'CUSTOMER BALANCE DETAILS AS OF ' + current_date" type="csv"
                  :name="'Customerbalance_details ' + current_date + '.xls'">
                  Export <i class="fa fa-file-excel"></i>
                </download-excel>

                <b-button @click="printDescriptiveLedger()"
                  style="background-color:#e612e6;border-color:#e612e6;color:#fff">
                  Detailed
                </b-button>

                <b-button @click="printLedger()" style="background-color:#e612e6;border-color:#e612e6;color:#fff">
                  <i class="fa fa-print"></i> Print
                </b-button>

                <b-button @click="$router.go(-1)" style="background-color:#e612e6;border-color:#e612e6;color:#fff">
                  <i class="fa fa-arrow-left"></i> Back
                </b-button>

              </div>
            </div>

            <!-- SHOW / SEARCH -->
            <div class="row mb-3 align-items-center">

              <div class="col-12 col-md-6 mb-2">
                <label class="d-flex align-items-center">
                  Show&nbsp;
                  <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>
                  &nbsp;entries
                </label>
              </div>

              <div class="col-12 col-md-6 mb-2 text-md-end">
                <label class="d-flex align-items-center justify-content-md-end">
                  Search:
                  <b-form-input v-model="filter" type="search" placeholder="Search..."
                    class="form-control form-control-sm ms-2"></b-form-input>
                </label>
              </div>

            </div>

            <!-- TABLE -->
            <div class="table-responsive mb-0">

              <b-table class="datatables" :items="CustomerBalanceDetails" :fields="fields" responsive
                :per-page="perPage" :current-page="currentPage" :sort-desc.sync="sortDesc" :filter="filter"
                :filter-included-fields="filterOn" @filtered="onFiltered">

                <template #cell(amountIn)="data">
                  {{ data.item.amountIn ? (data.item.amountIn).toLocaleString() : 0 }}
                </template>

                <template #cell(amountOut)="data">
                  {{ data.item.amountOut ? (data.item.amountOut).toLocaleString() : 0 }}
                </template>

                <template #cell(amount)="data">
                  {{ data.item.amount ? (data.item.amount).toLocaleString() : 0 }}
                </template>

                <template #cell(actions)="data">
                  <b-button-group>

                    <b-button v-if="ReceiptSettings.print_deposits == 1 && data.item.recno > 0" size="sm"
                      @click="Receipt_print(data.item.recno)"
                      style="background-color:#e612e6;border-color:#e612e6;color:#fff">
                      Reprint
                    </b-button>

                    <b-button variant="success" size="sm"
                      @click="Viewdetails(data.item.transaction, data.item.Category)">
                      Details
                    </b-button>

                  </b-button-group>
                </template>

              </b-table>

              <!-- TOTALS -->
              <div class="row mt-3 text-center text-md-start">

                <div class="col-12 col-md-4 mb-2">
                  <h5>
                    Total Debit:
                    <span class="text-danger">
                      {{ totals.totalout ? thousandSeperator(totals.totalout) : 0 }}
                    </span>
                  </h5>
                </div>

                <div class="col-12 col-md-4 mb-2">
                  <h5>
                    Total Credit:
                    <span class="text-danger">
                      {{ totals.totalin ? thousandSeperator(totals.totalin) : 0 }}
                    </span>
                  </h5>
                </div>

                <div class="col-12 col-md-4 mb-2">
                  <h5>
                    Total Balance:
                    <span class="text-danger">
                      {{
                        (totals.totalout - totals.totalin)
                          ? (totals.totalout - totals.totalin).toLocaleString()
                          : 0
                      }}
                    </span>
                  </h5>
                </div>

              </div>

              <!-- LOADER -->
              <div class="text-center">
                <h3 v-if="!CustomerBalanceDetails" class="text-primary">
                  <b-spinner variant="primary"></b-spinner>
                  Please wait...
                </h3>
              </div>

            </div>

            <!-- PAGINATION -->
            <div class="row mt-3">
              <div class="col-12 d-flex justify-content-md-end justify-content-center">
                <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>

  </Layout>
</template>